import AdminNavbar from "components/Navbar/Navbar";
import RequireAuth from "components/RequireAuth";
import Sidebar from "components/Sidebar/Sidebar";
import NotFound from "pages/NotFound/NotFound";
import React from "react";
import { Route, Routes } from "react-router-dom";
import userRoles from "utils/roles";
import { toggleContext } from "App";
import { firmsSidebarRoutes } from "data/sidebar";
import Profile from "pages/Profile/Profile";
import GovernmentAddSurvey from "pages/GovernmentAddSurvey/GovernmentAddSurvey";
import GovernmentListofSurvey from "pages/GovernmentListofSurvey/GovernmentListofSurvey";
import GovernmentPrincingplans from "pages/GovernmentPrincingplans/GovernmentPrincingplans";
import GovernmentBillingPlans from "pages/GovernmentBillingPlans/GovernmentBillingPlans";
import FileManager from "pages/FileManager/FileManager";
import GovernmentDashboard from "pages/GovernmentDashboard/GovernmentDashboard";
import GovernmentStartSurvey from "pages/GovernmentAddSurvey/GovernmentStartSurvey";
import AssessmentAnalysis from "pages/AssessmentAnalysis/AssessmentAnalysis";
import OpportunityList from "pages/OpportunityList/OpportunityList";
import OpportunityDetails from "pages/OpportunityDetails/OpportunityDetails";
import GrowthPlanAssessment from "pages/GrowthPlanAssessment/GrowthPlanAssessment";
import GrowthPlanAssessmentForm from "pages/GrowthPlanAssessmentForm/GrowthPlanAssessmentForm";

function FirmsLayout() {
  const [isopen, setisOpen] = React.useState(true);

  return (
    <>
      <toggleContext.Provider
        value={{
          isopen,
          setisOpen
        }}
      >
        <Sidebar routes={firmsSidebarRoutes} />
        <div className={isopen ? "sidecontainer" : "sidecontainerclose"}>
          <AdminNavbar />
          <div className="p-2">
            <Routes>
              <Route element={<RequireAuth allowedRoles={[userRoles.FIRMS]} />}>
                <Route path="dashboard" element={<GovernmentDashboard />} />
                <Route path="profile" element={<Profile />} />
                <Route path="add/Assessment" element={<GovernmentAddSurvey />} />
                <Route path="pending/Assessment/:id" element={<GovernmentAddSurvey />} />
                <Route path="start/Assessment" element={<GovernmentStartSurvey />} />
                <Route path="Assessment/list" element={<GovernmentListofSurvey />} />
                <Route path="assessment/analysis/:id" element={<AssessmentAnalysis />} />
                <Route path="plans" element={<GovernmentPrincingplans />} />
                <Route path="file-manager" element={<FileManager />} />
                <Route path="billing/plans" element={<GovernmentBillingPlans />} />
                <Route path="bid/opportunity" element={<OpportunityList />} />
                <Route path="bid/opportunity/:id" element={<OpportunityDetails />} />
                <Route path="growth-plan-assessment/add" element={<GrowthPlanAssessmentForm />} />
                <Route path="growth-plan-assessment" element={<GrowthPlanAssessment />} />
                <Route
                  path="/unauthorized"
                  element={
                    <NotFound
                      statusCode="403"
                      message="Sorry, you have no privilage to view this page."
                    />
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </div>
        </div>
      </toggleContext.Provider>
    </>
  );
}

export default FirmsLayout;
